import React , {useState, useEffect}from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Procesando from '../Generales/Procesando'
import {sucursal} from '../Generales/Storage';

function ConfiguracionSKUS(props) {
const [tipoDocumentos, setTipoDocumentos] =  useState([]);
const [cargando, setCargando] = useState(false);
const [inicial, setInicial] = useState("");
const [final, setFinal] = useState("");
const [siguiente, setSiguiente]= useState("");

useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    getDatos()
},[]);

async function getDatos(){
    setCargando(true);
    await axios.get(config.api_url+'/configuracion/skus/').then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            //setTipoDocumentos(resp.data.tipoDocumentos);
            setInicial(resp.data.skus.inicial);
            setFinal(resp.data.skus.final);
            setSiguiente(resp.data.skus.siguiente);
            setCargando(false);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al traer los datos!");
    })  
}

function ModificaInicio( valor){
    setInicial(valor);
}

function ModificaFin(valor){
    setFinal(valor);
}

function ModificaSiguiente(valor){
    setSiguiente(valor)
}

async function Guardar(){
    if(inicial> final){
        toast.error("El valor inicial no puede ser mayor que el final.")
        return;
    }
    if(siguiente < inicial || siguiente > final){
        toast.error("El valor siguiente no está en el rango.")
        return;
    }
    setCargando(true);
    await axios.post(config.api_url+'/configuracion/skus/', {inicial:inicial, final:final, siguiente:siguiente }).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            toast.success(resp.data.mensaje);
            setCargando(false);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al guardar los datos.");
    })  
}


return  (       
        <div className="contenedorMantenedor">
            <ToastContainer />
            <Modal
                open={cargando}
                showCloseIcon={false}
                center
                >
                <Procesando/>
            </Modal>
            <div className='card' style={{paddingLeft:"2%", paddingRight:"2%"}}>
                <div className='card-header'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <a href='/configuracion/home/'><i class="bi bi-arrow-left-short"></i>Regresar</a>   
                        </div>
                        <div className='col-md-4 titulo-formulario'>
                            <label >Configuración SKUS </label>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    {/*folio inicial */}
                    <div className='row filaFormEtiqueta'>
                        <div className='col-md-12 d-flex justify-content-start'>
                            <label className="etiquetaForm">Sku inicial:</label>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-2'>
                            <input type="text" value={inicial} onChange={(ev)=>ModificaInicio(ev.target.value)} className="form-control"></input>
                        </div>
                    </div>
                    {/*folio final */}
                    <div className='row filaFormEtiqueta'>
                        <div className='col-md-12 d-flex justify-content-start'>
                            <label className="etiquetaForm">Folio final:</label>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-2'>
                            <input type="text" value={final} onChange={(ev)=>ModificaFin(ev.target.value )} className="form-control"></input>
                        </div>
                    </div>
                    {/*Folio siguiente */}
                    <div className='row filaFormEtiqueta'>
                        <div className='col-md-12 d-flex justify-content-start'>
                            <label className="etiquetaForm">SKU siguiente:</label>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-2'>
                            <input type="text" value={siguiente} onChange={(ev)=>ModificaSiguiente( ev.target.value )} className="form-control"></input>
                        </div>
                    </div>
                    <br></br>
                    <div className='row'>
                        <div className='col-md-12'>
                            <button className='btn btn-formulario' onClick={Guardar}> Guardar </button>
                        </div>
                    </div>
                </div>     
            </div>
           
        </div>
    
    );
}

export default ConfiguracionSKUS;